import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LabelComponent from "pages/profile/common/label";
import { ReactComponent as EditIcon } from "images/profile/edit-icon.svg";

function ContactDetailsDisplay({
  onEditClick = () => {},
  isShowEditIcon = false,
}) {
  const [t] = useTranslation();
  const userDetails = useSelector((state) => state.userDetails || {});
  const contacts = userDetails?.contacts ?? [];
  const [isEditShowEditOnHover, setShowEditOnHover] = useState(false);

  return (
    <div
      id="contactDetailsSection"
      className={`flex p-[24px] flex-col gap-[12px] self-stretch cursor-pointer ${
        isEditShowEditOnHover ? "bg-[#F3F5F7]" : ""
      }`}
      onMouseEnter={() => setShowEditOnHover(true)}
      onMouseLeave={() => setShowEditOnHover(false)}
    >
      <div className="flex justify-between items-center self-stretch">
        <div className="text-[#1D1B22] font-semibold text-[24px]">
          {t("contactDetailsTitle")}
        </div>
        {isShowEditIcon && (
          <EditIcon
            className={`cursor-pointer ${
              isEditShowEditOnHover ? "visible" : "invisible"
            }`}
            onClick={onEditClick}
          />
        )}
      </div>

      {contacts.map((contact, i) => (
        <Fragment key={`${i}`}>
          <div className="flex flex-wrap gap-[20px]">
            <LabelComponent
              title={t("name")}
              subTitle={`${contact?.name ?? "-"}`}
            />
            <LabelComponent
              title={t("email")}
              subTitle={`${contact?.email ?? "-"}`}
            />
            <LabelComponent
              title={t("department")}
              subTitle={`${contact?.department ?? "-"}`}
            />
            <LabelComponent
              title={t("position")}
              subTitle={`${contact?.position ?? "-"}`}
            />
          </div>
          {i < contacts.length - 1 && (
            <div className="h-[1px] w-full grid bg-default-color" />
          )}
        </Fragment>
      ))}
    </div>
  );
}

ContactDetailsDisplay.propTypes = {
  onEditClick: PropTypes.func.isRequired,
  isShowEditIcon: PropTypes.bool,
};

export default ContactDetailsDisplay;
